import './init';

import $ from 'jquery';

import './app/header';
import './app/carousel';
// import './app/footerBrands';
// import './app/scrollUp';

$(() =>{
	if ($('form.form-filter').length) {
		import('./app/filters');
	}
});



// WEBPACK FOOTER //
// ./resources/js/app.js